import rpc from './core'

const urls = {
  rooms: {
    url: '/chat/{parish}/rooms',
    method: 'GET'
  },
  open: {
    url: '/chat/{parish}/open',
    method: 'POST'
  },
  update: {
    url: '/chat/update/{room}',
    method: 'POST'
  },
  close: {
    url: '/chat/close/{room}',
    method: 'POST'
  },
  user: {
    url: '/user/{user}/info',
    method: 'GET'
  }
}

const loadRoomsList = async (parish) => {
  return rpc({ params: { parish: parish.id }, ...urls['rooms'] })
}
const getUserInfo = async (user) => {
  return rpc({ params: { user: user.id }, ...urls['user'] })
}
const openRoom = async (parish, room) => {
  return rpc({ params: { parish: parish.id }, data: { chat_room: room }, ...urls['open'] })
}
const updateRoom = async (room) => {
  return rpc({ params: { room: room.id }, data: { chat_room: room }, ...urls['update'] })
}
const closeRoom = async (room) => {
  return rpc({ params: { room: room.id }, ...urls['close'] })
}

export default { loadRoomsList, getUserInfo, openRoom, updateRoom, closeRoom }
